import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactPlayer from 'react-player';
import { Field, reduxForm } from 'redux-form/immutable';
import numeral from 'numeral';

import { getTemporarySignedUrl } from '../../utils/s3-service';
import { loadDeliverable, createComment, clearDeliverable, approveDeliverable, changeSelectedDocumentVersion } from './actions';
import { YOUTUBE_URL, PDF_URL, DOC_URL, FILE_URL, IMAGE_URL, YOUTUBE, TWITTER, FACEBOOK, SNAPCHAT, INSTAGRAM } from '../../utils/static-configuration';
import DeliverableSubmitModal from '../../containers/deliverable-submit-modal';
import { setModal } from '../../actions/modal';
import TextareaInput from '../../components/form-input-textarea';
import Dropdown from '../../components/dropdown';
import { checkUserIsTeamMember, checkUserHasAdminRights } from '../../utils/role-service';
import Image from '../../components/image';
import { getDate } from '../../utils/helper-functions';
import AvatarProfile from '../../components/avatar';
import ImageModal from '../../components/image-modal';

class Deliverable extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      fixed: false,
      imageUrl: null,
      imageModal: null,
    };
  }

  componentWillMount() {
    const deliverableId = this.props.routeParams
      ? this.props.routeParams.id
      : null;
    if (!deliverableId) this.context.router.push('/');
    this.props.onLoadDeliverable(deliverableId);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = event => {
    const scrollTop = (window.pageYOffset || window.pageOffsetY) || 0;
    const { fixed } = this.state;

    if (scrollTop > 60 && !fixed) {
      this.setState({ fixed: true });
    }
    if (scrollTop <= 60 && fixed) {
      this.setState({ fixed: false });
    }
  };

  componentWillUnmount() {
    this.props.onClearDeliverable();
  }

  downloadFile = filePath => async e => {
    e.preventDefault();
    const downloadFileURL = await getTemporarySignedUrl(filePath);
  };

  settingsFeedback = action => {
    this.context.router.push(action);
  };

  showModal = docType => () => this.props.onSetModal(docType);
  updateDeliverableApproved = () => this.props.onApproveDeliverable();

  submitComment = formData => {
    const comment = formData.get('newComment');
    const { deliverable } = this.props;

    // Ignore empty comments
    if (!comment || (comment && !comment.trim())) {
      this.props.reset();
      return null;
    }

    const data = {
      comment,
      deliverableId: deliverable.get('id'),
      documentId: deliverable.get('document') ? deliverable.getIn(['document', 'id']) : null,
    };

    this.props.onCreateComment(data);
    this.props.reset();
  };

  toggleImageModal = url => {
    this.setState({ imageModal: this.state.imageModal ? null : url });
  };

  openFileURL = url => () => window.open(url, '_self');
  openExternalURL = url => () => {
    let externalURL = url;
    if (externalURL.indexOf('http://') === -1 && externalURL.indexOf('https://') === -1) externalURL = `http://${externalURL}`;
    window.open(externalURL, '_blank');
  };

  renderDeliverable = document => {
    if (!document) return null;

    const filePath = document.get('filePath') || null;
    const contentType = document.get('contentType') || null;
    const downloadURL = document.get('downloadURL') || null;
    const externalURL = document.get('externalURL') || null;
    const fileType = document.get('fileType') || null;
    const name = document.get('name') || '';
    const size = document.get('size') || 0;
    const formattedSize = numeral(size).format('0.0 b').replace('.0', '');

    const fileIconOptions = {
      DOC_URL: '/icons/word-document.svg',
      PDF_URL: '/icons/pdf-document.svg',
      FILE_URL: '/icons/generic-document.svg',
      EXTERNAL_URL: '/icons/link.svg',
    };

    if (fileType === 'text') {
      return (
        <div className="text-callout">
          <div className="text-container">
            <p>{filePath}</p>
          </div>
        </div>
      );
    }
    if (contentType === YOUTUBE_URL) {
      return (
        <div className="cinema-callout">
          <ReactPlayer
            url={filePath}
            width={'100%'}
            height={'500px'}
            controls
          />
        </div>
      );
    } else if (contentType === IMAGE_URL) {
      return (
        <div className="image-callout" onClick={() => this.toggleImageModal(downloadURL)}>
          <Image width={'100%'} height={'400px'} imageUrl={downloadURL} />
        </div>
      );
    } else
    if (downloadURL && (contentType === DOC_URL || contentType === PDF_URL || contentType === FILE_URL)) {
      return (
        <div className="document-callout" onClick={this.openFileURL(downloadURL)}>
          <img src={fileIconOptions[contentType]} alt="doc file" />
          <p className="document-name">{name}</p>
          <p className="small light document-size">{formattedSize} - click to download</p>
        </div>
      );
    }
    if (externalURL) {
      return (
        <div className="document-callout" onClick={this.openExternalURL(externalURL)}>
          <img src={fileIconOptions[contentType]} alt="external url" />
          <p>{externalURL}</p>
          <p className="small light">click to open in a new tab</p>
        </div>
      );
    }
  };

  onSelectDocumentDropdown = action => {
    this.props.onChangeSelectedDocumentVersion({ version: action.version });
  };

  render() {
    const {
      loading,
      deliverable,
      error,
      handleSubmit,
      myUserRole,
      document,
      mostRecentDocument,
      documentVersionOptions,
      selectedVersion,
    } = this.props;
    const { fixed, imageModal } = this.state;
    const title = deliverable ? deliverable.get('title') : null;
    const dueDate = deliverable ? new Date(deliverable.get('dueDate')) : null;
    const liveDateEnd = deliverable ? new Date(deliverable.get('liveDateEnd')) : null;
    const assetType = deliverable ? `${deliverable.get('assetType')},` : null;
    const assetTypeFormatted = assetType ? assetType.split(',') : null;

    const filePath = document ? document.get('filePath') : null;
    const getImageUrl = this.downloadFile(filePath);
    const comments = deliverable ? deliverable.get('comments') : null;
    const discussionId = deliverable ? deliverable.getIn(['discussion', 'id']) : null;
    const discussionName = deliverable ? deliverable.getIn(['discussion', 'name']) : null;
    const description = deliverable ? deliverable.get('description') : null;
    const deliverableVersion = deliverable ? deliverable.get('version') : null;
    const documentVersion = document ? document.get('version') : null;
    const copyRequirements = document.get('message') || null;

    const isUserTeamMember = checkUserIsTeamMember(myUserRole);
    const isUserAnAdmin = checkUserHasAdminRights(myUserRole);

    const channelType = deliverable ? deliverable.get('channelType') : null;

    const deliverableAdded = (mostRecentDocument && mostRecentDocument.size > 0);
    const deliverableApproved = mostRecentDocument ? mostRecentDocument.get('approved') : null;

    return (
      <div className="page">
        { error && !loading &&
          <p>{error}</p>
        }
        { loading &&
          <div className="preloader">
            <img src="/icons/dyzio-icon.svg" alt="Loading..." />
          </div>
        }
        <div className="cinema-wrapper">
          <div className={`discussion-header ${fixed}`}>
            <div onClick={() => this.context.router.push(`/campaign/discussion/${discussionId}`)} className="one">
              <img src="/icons/chevron-left.svg" alt="back to discussion" />
            </div>
            <div className="two" onClick={() => this.context.router.push(`/campaign/discussion/${discussionId}`)}>
              { loading ? <h3>Loading...</h3> : <h3>{discussionName}</h3>}
            </div>
            <div className="three" />
            <div className="flex-spacer" />
            <div className="four" />
          </div>
          { !loading && deliverable && document &&
            this.renderDeliverable(document)
          }
          { !loading && copyRequirements &&
            <div className="deliverable-copy-text">
              <p>{copyRequirements}</p>
            </div>
          }
        </div>
        { !loading && deliverable &&
          <div className="deliverable">
            <div className="right">
              { deliverableAdded &&
                <div>
                  <h4>Approval</h4>
                  <div className="spacer small" />
                  <p className="small">
                    { isUserTeamMember
                      ? 'Once approved the influencer will be instructed to set it live on the live date'
                      : 'Once approved please set it live on the live date stated'
                    }
                  </p>
                  <div className="spacer" />
                  { !deliverableApproved && isUserTeamMember &&
                    <button onClick={this.updateDeliverableApproved} className="large seagreen stretch">
                      <p>approve</p>
                    </button>
                  }
                  { !deliverableApproved && !isUserTeamMember &&
                    <button className="large stretch disabled">
                      <p>await approval...</p>
                    </button>
                  }
                  { deliverableApproved &&
                    <button className="large stretch outline-seagreen">
                      <p>approved</p>
                    </button>
                  }
                </div>
              }
            </div>
            <div className="left">
              { deliverableVersion > 1 &&
                <Dropdown
                  align="right"
                  onClick={this.onSelectDocumentDropdown}
                  content={documentVersionOptions}
                >
                  <span className="clickable">
                    <a>VERSION {selectedVersion}
                      &nbsp;<span className="light small">{ deliverableVersion === documentVersion ? '(LATEST)' : '' }</span>
                      &nbsp;<img src="/icons/chevron-down.svg" alt="document-version" />
                    </a>
                  </span>
                </Dropdown>
              }
              <div className="spacer small" />
              <h1>{title}</h1>
              <div className="spacer" />
              <div className="row">
                { assetTypeFormatted.map(asset => {
                  if (asset && asset.length) {
                    return (
                      <div className="flex-item" key={asset}>
                        <img src={`/icons/${asset.toLowerCase()}-asset.svg`} alt={asset} />
                      </div>
                    );
                  }
                })}
                <div className="flex-item">
                  { channelType === YOUTUBE || channelType === FACEBOOK || channelType === INSTAGRAM || channelType === TWITTER || channelType === SNAPCHAT
                    ? <p><img src={`/icons/${channelType.toLowerCase()}-round.svg`} alt={channelType} />&nbsp;&nbsp;&nbsp;</p>
                    : <p className="channel-type-text">{channelType}</p>
                  }
                </div>
                <div className="flex-item">
                  <p>
                    <strong>Due date: </strong>
                    { moment(dueDate).format('ddd D MMM') }
                  </p>
                </div>
                <div className="flex-item">
                  <p>
                    <strong>Live date: </strong>
                    { moment(liveDateEnd).format('ddd D MMM') }
                  </p>
                </div>
              </div>
              { description &&
                <div className="row">
                  <div className="flex-item">
                    <p><strong>Requirements: </strong>{description}</p>
                  </div>
                  <div className="flex-spacer" />
                </div>
              }
              <div className="spacer large" />
              <div className="break" />
              <div className="spacer" />
              <h4 className="image-heading"><img src="/icons/comment.svg" alt="comments" />Comments</h4>
              <div className="spacer small" />
              <form onSubmit={handleSubmit(this.submitComment)}>
                <Field component={TextareaInput} name="newComment" placeholder="" />
                <div className="spacer small" />
                <div className="align-right">
                  <button type="submit" className="medium rose small-image">
                    Add comment&nbsp;&nbsp;&nbsp;
                    <img src="/icons/send-white.svg" alt="send comment" />
                  </button>
                </div>
              </form>
              { comments.size > 0 &&
                <div>
                  <h4>{`${comments.size} ${comments.size === 1 ? 'comment' : 'comments'}`}</h4>
                  <div className="spacer small" />
                  <div className="break" />
                  <div className="spacer" />
                  { comments.map(commentData => {
                    const id = commentData.get('id');
                    const senderName = commentData.get('createdBy');
                    const dateSent = new Date(commentData.get('createdDate'));
                    const dateFormatted = getDate(dateSent);
                    const comment = commentData.get('comment');
                    const commentType = commentData.get('commentType');
                    return (
                      <div key={id} className="simple-message">
                        <div className="top">
                          <div className="avatar">
                            <AvatarProfile name={senderName} size={36} plain />
                          </div>
                          <div className="user-info">
                            <p>{senderName}&nbsp;&nbsp;<span className="light">{moment(dateSent).format('ddd D MMM hh:mm')}</span></p>
                          </div>
                        </div>
                        <div className="content-container">
                          <div className="spacer small" />
                          { commentType === 'VERSION'
                            ? <div className="version-container">
                              <img src="/icons/added.svg" />
                              <p>{comment}</p>
                            </div>
                            : <p>{comment}</p>}
                          <div className="spacer" />
                        </div>
                      </div>
                    );
                  })}
                </div>
              }
            </div>
            { imageModal &&
              <ImageModal
                url={imageModal}
                alt="image-deliverable"
                onClear={this.toggleImageModal}
              />
            }
          </div>
        }
        <DeliverableSubmitModal />
      </div>
    );
  }
}

Deliverable.propTypes = {
  routeParams: React.PropTypes.object,
};

const mapStateToProps = state => ({
  myUserRole: state.campaign.get('myUserRole'),
  loading: state.deliverable.get('loading'),
  deliverable: state.deliverable.get('data'),
  document: state.deliverable.get('selectedDocument'),
  mostRecentDocument: state.deliverable.get('mostRecentDocument'),
  documentVersionOptions: state.deliverable.get('documentVersionOptions'),
  selectedVersion: state.deliverable.get('selectedVersion'),
  error: state.deliverable.get('error'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLoadDeliverable: deliverableId => dispatch(loadDeliverable(deliverableId)),
    setLoadingDeliverable: () => dispatch(loadingDeliverable()),
    onCreateComment: data => dispatch(createComment(data)),
    onClearDeliverable: () => dispatch(clearDeliverable()),
    onApproveDeliverable: () => dispatch(approveDeliverable()),
    onSetModal: modalName => dispatch(setModal(modalName)),
    onChangeSelectedDocumentVersion: data => dispatch(changeSelectedDocumentVersion(data)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'DeliverableComment',
  })(Deliverable),
);



/** WEBPACK FOOTER **
 ** ./src/containers/deliverable/index.js
 **/